/**
 * @file
 * Swiper slider.
 *
 */
(function(Drupal, once) {

  'use strict';

  Drupal.behaviors.swiperSlider = {
    attach: function(context, settings) {
      const sliders = once('SwiperSlider', '.swiper', context);
      sliders.forEach(processingSwiperSlider);
    }
  };

  /**
   * Swiper slider handler.
   *
   * @param element
   */
  function processingSwiperSlider(element) {
    new Swiper(element, {
      loop: true,
      autoplay: {
        delay: 5000,
      },
      slidesPerView: 4,
      spaceBetween: 30,
      breakpoints: {
        320: {
          slidesPerView: 1
        },
        600: {
          slidesPerView: 2
        },
        1200: {
          slidesPerView: 4
        },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }

})(Drupal, once);
